<template>
    <div class="exam-results">
        <div v-if="isBusy" class="text-center">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
        </div>
        <div v-else>

            <div v-if="showStartSlide">

                <div class="row justify-content-center mb-3">
                    <div class="col-md-12">
                        <div class="border p-5 text-center">
                            <p><strong>Grade</strong></p>
                            <p class="h1">{{ exam.grade }}</p>
                        </div>
                    </div>
                    <!--
                    <div class="col-md-6">
                        <div class="border p-5 text-center">
                            <p><strong>Marks</strong></p>
                            <p class="h1">{{ exam.marks }}/{{ exam.totalMarks }}</p>
                        </div>
                    </div>
                    -->
                </div>

                <div v-if="enrolment.hasPassed">
                    <div class="border p-3 text-center mb-3">
                        <p class="mt-3">
                            <a :href="'/assessments/certificate/' + enrolment.id" class="btn btn-primary" @click="isCertificateDisabled = true" :class="{ disabled: isCertificateDisabled }">Download Certificate</a>
                        </p>
                        <p>
                            <small class="text-muted">Your certificate is a PDF. Please download and store it safely. Only you can view the certificate from the link above.</small>
                        </p>
                    </div>
                </div>

                <div class="border p-3" v-if="exam.summaryText.length > 0 || exam.summaryVideo">
                    <h2>Examiner Notes</h2>
                    <div v-html="exam.summaryText"></div>
                    <div v-if="exam.summaryVideo">
                        <mux-video-component type="exam-enrolment-examiner-summary" :entity="enrolment"></mux-video-component>
                    </div>
                </div>

                <div class="mt-5">
                    <button class="btn btn-primary" @click="showStartSlide = false; toTop()">Results & Feedback</button>
                </div>

                <hr>

                <p>
                    You have attempted this assessment <strong>{{ exam.numEnrolments }} time{{ exam.numEnrolments > 1 ? 's' : '' }}</strong>.<br>
                    <template v-if="exam.numAllowedEnrolments - exam.numEnrolments > 0">
                        You can resit this assessment <strong>{{ exam.numAllowedEnrolments - exam.numEnrolments }} more time{{ exam.numAllowedEnrolments - exam.numEnrolments > 1 ? 's' : '' }}</strong>.
                    </template>
                    <template v-else>
                        You have reached the maximum number of attempts for this assessment.
                    </template>
                </p>

                <template v-if="isFree && exam.numAllowedEnrolments - exam.numEnrolments > 0">
                    <enrol-exam-button-component
                        :exam="examObj"
                        :user="user"
                        :inline="true"
                        :purchase-intent="'free'">Resit Assessment</enrol-exam-button-component>
                </template>
                <template v-else-if="!isFree && exam.numAllowedEnrolments - exam.numEnrolments > 0">
                    <button class="btn btn-primary" @click="$refs.buyModal.show()">Resit Assessment</button>
                </template>
            </div>
            <div v-else>
                <h2>{{ currentModule.title }}</h2>

                <div v-for="question in currentModule.questions" :key="question.id">
                    <div class="question mb-4 border p-3" v-if="question.is_answered">
                        <h4>{{ question.question }}</h4>

                        <div v-html="question.description" v-if="question.description"></div>

                        <template v-if="question.type === 'amc' || question.type === 'aft'">
                            <audio :src="question.question_audio_file" controls></audio>
                        </template>

                        <div v-if="question.type === 'samc' || question.type === 'amc'">
                            <ul class="list-unstyled mb-0">
                                <li v-for="answer in question.answers" :key="answer.id">
                                    <input type="radio" :id="answer.id" :name="question.id" :value="answer.id" :checked="answer.is_user_answer" disabled>
                                    <label :for="answer.id">{{ answer.answer }}</label>
                                </li>
                            </ul>
                            <!--
                            <p class="mb-0">
                                <span v-if="question.is_correct" class="badge badge-success">Correct</span>
                                <span v-else class="badge badge-danger">Incorrect</span>

                                <strong v-if="question.is_markable">{{ question.marks }}/{{ question.available_marks }} marks awarded</strong>
                            </p>
                            -->
                        </div>

                        <div v-if="question.type === 'mamc'">
                            <ul class="list-unstyled mb-0">
                                <li v-for="answer in question.answers" :key="answer.id">
                                    <input type="checkbox" :id="answer.id" :name="question.id" :value="answer.id" :checked="answer.is_user_answer" disabled>
                                    <label :for="answer.id">{{ answer.answer }}</label>
                                </li>
                            </ul>

                            <!--
                            <p class="mb-0">
                                <span v-if="question.is_correct" class="badge badge-success">Correct</span>
                                <span v-else class="badge badge-danger">Incorrect</span>

                                <strong v-if="question.is_markable">{{ question.marks }}/{{ question.available_marks }} marks awarded</strong>
                            </p>
                            -->
                        </div>

                        <div v-if="question.is_timed_out">
                            <p class="text-danger">You ran out of time for this question. 0 marks were awarded.</p>
                        </div>
                        <div v-else>
                            <div v-if="['text', 'aft', 'audio', 'video'].includes(question.type)">
                                <p class="mb-0 mt-2">
                                    <strong>Your Answer:</strong>
                                </p>

                                <template v-if="question.type === 'audio'">
                                    <audio :src="question.answer_audio_file" controls></audio>
                                </template>

                                <template v-if="question.type === 'video'">
                                    <mux-video-component type="exam-enrolment-user-answer" :entity="question.user_answer_video_entity"></mux-video-component>
                                </template>

                                <div v-html="nl2br(question.answer)" class="mb-2"></div>

                                <!--
                                <p class="mb-0">
                                    <strong v-if="question.is_markable">{{ question.marks }}/{{ question.available_marks }} marks awarded</strong>
                                </p>
                                -->
                            </div>
                        </div>

                        <div v-if="question.examiner_summary_text.length > 0 || question.examiner_summary_video" class="p-3 border examiner-feedback mb-0">
                            <h4>Examiner Feedback</h4>
                            <div v-if="question.examiner_summary_text.length > 0" v-html="question.examiner_summary_text"></div>
                            <div v-if="question.examiner_summary_video" class="mt-4 mb-0">
                                <mux-video-component type="exam-enrolment-examiner-question-feedback" :entity="question.examiner_summary_video_entity"></mux-video-component>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5">
                    <button class="btn btn-primary" @click="previousModule" v-if="currentModuleIndex !== 0">Previous Module</button>
                    <button class="btn btn-primary" @click="showStartSlide = true; toTop()" v-else>Back to summary</button>
                    <button class="btn btn-primary" @click="nextModule" v-if="currentModuleIndex !== (modules.length - 1)">Next Module</button>
                </div>
            </div>
        </div>

        <template v-if="!isFree">
            <b-modal ref="buyModal" size="lg" centered :title="'Purchase resit of ' + examObj.name" :ok-only="true" ok-variant="link" ok-title="Close">
                <buy-exam-button-component
                    :exam="examObj"
                    :user="user"
                    :is-new-user="false"></buy-exam-button-component>
            </b-modal>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        enrolment: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            modules: [],
            exam: {},
            examObj: {},
            user: {},
            currentModuleIndex: 0,
            isBusy: true,
            showStartSlide: true,
            isCertificateDisabled: false,
            isFree: false,
            isAuth: false,
        };
    },
    computed: {
        currentModule() {
            return this.modules[this.currentModuleIndex];
        },
    },
    mounted() {
        this.fetchExamResults();

        // User logged in?
        if(window.virtuoso) {
            if(window.virtuoso.is_auth) {
                this.isAuth = true;
                this.user = window.virtuoso.user;
            }
        }
    },
    methods: {
        fetchExamResults() {
            axios.get(`/api/examroom/${this.enrolment.id}/results`)
                .then(response => {
                    this.modules = response.data.modules;
                    this.exam = response.data.exam;
                    this.examObj = response.data.examObj; // Original exam model
                    this.isFree = this.exam.is_free;
                })
                .catch(error => {
                    console.error('Error fetching exam results:', error);
                    // Handle error appropriately
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        previousModule() {
            if (this.currentModuleIndex > 0) {
                this.currentModuleIndex--;
            }

            this.toTop();
        },
        nextModule() {
            if (this.currentModuleIndex < this.modules.length - 1) {
                this.currentModuleIndex++;
            }

            this.toTop();
        },

        // Scroll to top
        toTop() {
            window.scrollTo(0, 0);
        },

        // Convert newlines to <br> tags
        nl2br (str) {
            if (typeof str === 'undefined' || str === null) {
                return '';
            }
            var breakTag = '<br>';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },
    },
};
</script>
<style>
.disable-link{
    pointer-events: none;
}
</style>
